import styled from 'styled-components'

export const StyledHomeWrapper = styled.div`
  .access-level-table {
    &__row {
      border: none;
      background-color: rgba(204, 204, 204, 0.2);
      &:nth-child(2n) {
        background-color: #fff;
      }
    }
    @media screen and (max-width: 992px) {
      &__body {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 15px;
      }
      &__row {
        background-color: #fff;
        border: 1px solid #E5E5E5;
        border-radius: 5px;
      }
    }
  }
`;


export const StyledHomeWarning = styled.div`
  margin-top: 16px;
  
  p {
    padding-bottom: 8px;
    
    &:first-child {
      font-weight: 600;
    }
  }
`;